/* eslint-disable import/no-cycle */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../packageSource/actionTypes';
import { setPackageSourceList } from '../../packageSource/actions';
import { getPackageSourceApi } from '../requests/packageRequest';
import { startLoader, stopLoader } from '../../../utility/commonFunction';

function* getPackageSourceListHandler(action) {
  const { packageId, type } = action.payload || {};
  if (!packageId || !type) {
    return;
  }
  try {
    yield startLoader('transparent');
    const { data } = yield call(getPackageSourceApi, packageId, type);
    const responseData = data?.status ? data?.data : null;
    if (responseData) {
      yield put(setPackageSourceList({ packageId, type, data: responseData }));
    } else if (!data?.status && data?.errors?.message) {
      yield toast.error(data?.errors?.message);
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || 'Failed to fetch list');
  } finally {
    yield stopLoader('transparent');
  }
}

export default function* packageSourceSaga() {
  yield takeLatest(types.GET_PACKAGE_SOURCE_LIST, getPackageSourceListHandler);
}
